// Shared per-viewer localStorage scoping for the recording-recovery stores
// (dismissals, recovered notices, recovery locks/give-up counters, heartbeat).
// Single-sourced so the stores can never disagree on who "the viewer" is.
//
// Reads the `user` key — the login email that useAuth actually persists at
// login (useAuth.js writes loginToken/sessionId/user/organization). The
// previous per-store copies of this helper read an `auth` key that NOTHING in
// production writes (only tests seeded it), so every store silently fell back
// to one shared "anonymous" bucket: two operators on the same machine shared
// dismissals, give-up counters and recovered notices (with their encounter
// links) — a cross-user leak on shared clinic workstations.
export function recordingViewerKey() {
  try {
    return localStorage.getItem("user") || "anonymous";
  } catch {
    return "anonymous";
  }
}
